import React from "react";
import "../../styles/HomeSection/HomeSectionImage.scss";
export const HomeSectionImage = () => {
  return (
    <div className="building-container">
      <img
        className="building-mask"
        src={"/images/building.png"}
        alt="building"
      />
      <img
        className="background-image"
        src={"/images/buildingw.png"}
        alt="building"
      />
    </div>
  );
};
